import accessors from '../accessors';

const canBeRemoved = (element) => Boolean(accessors.getRemoveConstraintForElement(element));

export default canBeRemoved;
